<script setup lang="ts">
import { ButtonSize } from '@/hooks/useButtonClasses';

import Button from '@/components/button/Button.vue';
import FormRows from '@/components/formRows/FormRows.vue';
import FormTextInput from '@/components/formTextInput/FormTextInput.vue';
import PasswordRequirementsList from '@/components/passwordRequirementsList/PasswordRequirementsList.vue';
import PasswordStrength from '@/components/passwordStrength/PasswordStrength.vue';

import Check from '@/icons/line/check.svg';

import AbstractTriangle from '@/images/abstract-triangle.svg';

const form = useForm({
  method: 'PUT',
  url: route('student.password.setup.update'),
  fields: {
    password: '',
    password_confirmation: ''
  }
});

const passwordScore = ref(0);

const isPasswordLongEnough = computed(() => form.fields.password.length >= 8);
const doPasswordsMatch = computed(
  () =>
    form.fields.password.length > 0 && form.fields.password === form.fields.password_confirmation
);

const handleScoreChange = (score: number) => {
  passwordScore.value = score;
};
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/domains/auth/layouts/two-columns-guest.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <div class="flex flex-col gap-y-6">
    <div class="flex items-center justify-between">
      <div class="flex flex-col gap-2">
        <h1 class="text-left text-2xl font-semibold leading-9 text-slate-900 sm:text-3xl">
          Welcome
        </h1>
        <p class="text-md leading-relaxed text-slate-700">
          To get started, please set up a password.
        </p>
      </div>
      <AbstractTriangle class="h-18 w-18" />
    </div>
    <form class="flex flex-col gap-y-8" @submit.prevent="form.submit">
      <div class="flex flex-col gap-y-1">
        <FormRows>
          <FormTextInput
            label="Password"
            name="password"
            autofocus
            v-model="form.fields.password"
            type="password"
            placeholder="New Password"
            :error="form.errors.password"
          >
            <template #helperText>
              <PasswordStrength :password="form.fields.password" @score="handleScoreChange" />
            </template>
          </FormTextInput>
          <FormTextInput
            label="Confirm Password"
            name="password_confirmation"
            v-model="form.fields.password_confirmation"
            type="password"
            placeholder="Confirm New Password"
          />
        </FormRows>
        <PasswordRequirementsList
          :isPasswordLongEnough="isPasswordLongEnough"
          :doPasswordsMatch="!!doPasswordsMatch"
          :passwordScore="passwordScore"
          class="pt-6"
        />
      </div>
      <div class="flex flex-col">
        <Button
          :isDisabled="!doPasswordsMatch || !isPasswordLongEnough || form.processing"
          :iconLeft="Check"
          :size="ButtonSize.lg"
          :isLoading="form.processing"
          type="submit"
          useMediaQuery
        >
          Set password
        </Button>
      </div>
    </form>
  </div>
</template>
